import { PersonAddOutlined } from "@mui/icons-material";
import { Card } from "@mui/material";
import Button from "@mui/material/Button";
import { memo, useCallback, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ScreenContent from "../../../../components/layout/ScreenContent";
import TitledHeaderWithSearch from "../../../../components/layout/TitledHeaderWithSearch";
import { loanDrilldownSidebarTypes } from "../../../../constants/enums/loanDrilldownScreenSidebarOptions";
import {
  sidebarSetStateValue,
  sidebarTypeSet,
  sidebarTypeToggle,
} from "../../../../redux/actions/sidebarActions";
import LoanDrilldownTabPanel from "../LoanDrilldownTabPanel";

import LoanContactsTable from "./LoanContactsTable";
import { isEmpty } from "lodash";
import Txt from "../../../../components/typography/Txt";

const LoanDrilldownContactsTab = ({ value, tab }) => {
  const ref = useRef();
  const { contactId } = useParams();

  const [quickFilter, setQuickFilter] = useState(null);
  const [contactData, setContactData] = useState(null);
  const dispatch = useDispatch();
  const loanRelatedContacts = useSelector(
    (state) => state?.loanDrilldown?.loanRelatedContacts || []
  );

  // Find the selected borrower based on URL parameter
  const selectedContact = useMemo(() => {
    if (!contactId || !loanRelatedContacts.length) return null;
    return (
      loanRelatedContacts.find((contact) => contact._id === contactId) || null
    );
  }, [contactId, loanRelatedContacts]);

  const handleOnRowClicked = useCallback((d) => {
    dispatch(
      sidebarTypeSet(loanDrilldownSidebarTypes.ADD_LOAN_RELATED_CONTACT)
    );
    dispatch(sidebarSetStateValue(d));
  }, []);
  return (
    <LoanDrilldownTabPanel>
      <TitledHeaderWithSearch
        title={"Loan Related Contacts"}
        endContent={<AddBorrowerButton />}
        borderColor={"#eeeeee"}
      />

      <ScreenContent>
        {isEmpty(loanRelatedContacts) ? (
          <Txt secondary>No related contacts added.</Txt>
        ) : (
          <Card
            sx={{
              p: 0,
              overflow: "hidden",
              mb: 4,
            }}
          >
            <LoanContactsTable
              rowData={loanRelatedContacts}
              ref={ref}
              selectedId={selectedContact?._id}
              onRowClicked={(data) => handleOnRowClicked(data)}
              quickFilterText={quickFilter}
            />
          </Card>
        )}
      </ScreenContent>
    </LoanDrilldownTabPanel>
  );
};

const AddBorrowerButton = memo(() => {
  const dispatch = useDispatch();

  const onAdd = useCallback(() => {
    dispatch(
      sidebarTypeSet(loanDrilldownSidebarTypes.ADD_LOAN_RELATED_CONTACT)
    );
    dispatch(sidebarSetStateValue(null));
  }, [dispatch]);

  return (
    <Button sx={{ ml: 1 }} startIcon={<PersonAddOutlined />} onClick={onAdd}>
      Add Loan Contact
    </Button>
  );
});

export default LoanDrilldownContactsTab;
